import { useEffect, useState } from 'react';
import { CustomerPreview } from 'services';

/**
 * Synchronously determines whether we MIGHT be in preview mode based on the URL.
 * Returns true only when the URL suggests preview so that in the normal app case
 * isPending starts as false, avoiding a state update that can be lost during
 * React 18 StrictMode's synchronous cleanup phase.
 */
const mightBePreviewMode = () => {
  const { pathname, search } = window.location;

  return (
    /customer-preview=true/.test(search) ||
    /live-customer-portal-preview/.test(pathname)
  );
};

/**
 * This is for the default customer portal
 */
export const useCustomerPreview = () => {
  const [isPending, setIsPending] = useState(() => mightBePreviewMode());
  const [isPreview, setIsPreview] = useState<boolean | null>(null);
  const [projectId, setProjectId] = useState<number | null>(null);

  useEffect(() => {
    CustomerPreview.isPreviewMode()
      .then((result) => {
        if (!result[0]) {
          setIsPreview(false);
          setIsPending(false);

          return;
        }
        setProjectId(result[1]);
        setIsPreview(true);
        setIsPending(false);
      })
      .catch(() => {});
  }, []);

  return { isPreview, isPending, projectId };
};
export const CUSTOMER_PORTAL_PREVIEW = 'customer-portal-preview';
